import React from 'react';
import Card from './Card';
import {Box, Typography} from "@mui/material";
import publ1 from '../../img/publ_1.png';
import publ2 from '../../img/publ_2.png';
import publ3 from '../../img/publ_3.png';
import publ4 from '../../img/publ_4.png';
import publ5 from '../../img/publ_5.png';

function Publications({innerRef}) {
    const publications = [
        {
            imagePath: publ1,  // Percorso dell'immagine
            title: 'A Deep Learning Approach for Virtual Contrast Enhancement in Contrast Enhanced Spectral Mammography',  // Titolo della pubblicazione
            authors: 'Aurora Rofena, Valerio Guarrasi, Marina Sarli, Claudia Lucia Piccolo, Matteo Sammarra, Bruno Beomonte Zobel, Paolo Soda',  // Autori della pubblicazione
            links: [
                {
                    url: 'https://www.sciencedirect.com/science/article/pii/S0895611124000752',
                    label: 'Computerized Medical Imaging and Graphics, 2024'
                },
                {
                    url: 'https://github.com/cosbidev/VCE_CESM',
                    label: "Project Page"
                }
            ]
        },
        {
            imagePath: publ2,  // Percorso dell'immagine
            title: 'A Systematic Review of Intermediate Fusion in Multimodal Deep Learning for Biomedical Applications',  // Titolo della pubblicazione
            authors: 'Valerio Guarrasi, Fatih Aksu, Camillo Maria Caruso, Francesco Di Feola, Aurora Rofena, Filippo Ruffini, Paolo Soda',  // Autori della pubblicazione
            links: [
                {
                    url: 'https://arxiv.org/abs/2408.02686',
                    label: 'arXiv, 2024'
                },
            ]
        },
        {
            imagePath: publ3,  // Percorso dell'immagine
            title: 'Radiomics for Predicting Prognostic Factors in Breast Cancer: Insights from Contrast-Enhanced Mammography (CEM)',  // Titolo della pubblicazione
            authors: 'Claudia Lucia Piccolo, Marina Sarli, Matteo Pileri, Manuela Tommasiello, Aurora Rofena, Valerio Guarrasi, Paolo Soda, Bruno Beomonte Zobel',  // Autori della pubblicazione
            links: [
                {
                    url: 'https://www.mdpi.com/2077-0383/13/21/6486',
                    label: 'MDPI Journal of Clinical Medicine, 2024'
                },
            ]
        },
                {
            imagePath: publ4,  // Percorso dell'immagine
            title: 'Virtual scanner: leveraging resilient generative ai for radiological imaging in the era of medical digital twins',  // Titolo della pubblicazione
            authors: 'Valerio Guarrasi, Lorenzo Tronchin, Camillo Maria Caruso, Aurora Rofena, Guido Manni, Fatih Aksu, Domenico Paolo, Giulio Iannello, Rosa Sicilia, Ermanno Cordelli, Paolo Soda',  // Autori della pubblicazione
            links: [
                {
                    url: 'https://www.diva-portal.org/smash/record.jsf?pid=diva2:1809300',
                    label: 'Ital-IA, 2023'
                },
            ]
        },
                        {
            imagePath: publ5,  // Percorso dell'immagine
            title: 'Building an AI-enabled metaverse for intelligent healthcare: opportunities and challenges',  // Titolo della pubblicazione
            authors: 'Carolina Adornato, Cecilia Assolito, Ermanno Cordelli, Francesco Di Feola, Valerio Guarrasi, Giulio Iannello, Lorenzo Marcoccia, Elena Mulero Ayllon, Rebecca Restivo, Aurora Rofena, Rosa Sicilia, Paolo Soda, Matteo Tortora, Lorenzo Tronchin',  // Autori della pubblicazione
            links: [
                {
                    url: 'https://www.diva-portal.org/smash/record.jsf?pid=diva2:1908556',
                    label: 'Ital-IA, 2024'
                },
            ]
        },
    ];

    return (
        <Box ref={innerRef} display="flex" flexDirection="column" alignItems="center" mt={4} id={"publications"}>
            <Typography variant="body1" sx={{fontWeight: 'normal', fontSize: '17px', fontFamily: 'Roboto'}} mb={2}>
                A complete and up-to-date list of publications can be found on <a
                href="https://scholar.google.com/citations?user=I65WdP4AAAAJ&hl=it&oi=ao" target="_blank" rel="noopener noreferrer"
                style={{color: "#793eee", textDecoration: "none"}}>Google Scholar</a>.
            </Typography>
            {publications.map((pub, index) => (
                <Card
                    key={index}
                    imagePath={pub.imagePath}
                    title={pub.title}
                    authors={pub.authors}
                    links={pub.links}
                />
            ))}
        </Box>
    );
}

export default Publications;
